import { Command, useCommandState } from 'cmdk';

export function CommandEmpty() {
  const search = useCommandState((state) => state.search);
  return (
    <Command.Empty className="py-6 text-center text-sm text-gray-500 dark:text-gray-400">
      No results found for &ldquo;{search}&rdquo;.
    </Command.Empty>
  );
}
